const img = require('./Angled Frame.svg'); export default img;